/* import __COLOCATED_TEMPLATE__ from './media-inserter.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { ref } from 'ember-ref-bucket';
let MediaInserter = (_dec = ref('mediaInserter'), (_class = class MediaInserter extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isExpanded", _descriptor, this);
    _initializerDefineProperty(this, "mediaInserter", _descriptor2, this);
    //activeInsertionPoint needs to be tracked to trigger a re-render specifically for insertionPointIsInTable
    _initializerDefineProperty(this, "activeInsertionPoint", _descriptor3, this);
  }
  get state() {
    return this.args.composer.state;
  }
  expand() {
    this.activeInsertionPoint = this.state.hoverInfo.nearestInsertionPoint || null;
    this.isExpanded = true;
  }
  insertBlock(block) {
    this.isExpanded = false;
    let pos = null;
    if (this.activeInsertionPoint) {
      pos = this.activeInsertionPoint.pos;
      this.args.composer.commands.insertBlockAtRange({
        from: pos,
        to: pos
      }, block);
      this.args.composer.commands.focus();
    } else {
      throw new Error('Tried to insert a block without an active insertion point');
    }
    return pos;
  }
  closeIfEditing() {
    if (this.state.isEditing) {
      this.isExpanded = false;
    }
  }
  onMouseUp(isInsertingIfElseStatement, e) {
    if (!isInsertingIfElseStatement && !this.mediaInserter.contains(e.target)) {
      this.isExpanded = false;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isExpanded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "mediaInserter", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "activeInsertionPoint", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "expand", [action], Object.getOwnPropertyDescriptor(_class.prototype, "expand"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeIfEditing", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeIfEditing"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onMouseUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onMouseUp"), _class.prototype)), _class));
export { MediaInserter as default };